export default __webpack_public_path__ + "static/media/img-b-charge-car@2x.0574eaed.png";